module.exports = __webpack_public_path__ + "static/media/map.f9e71438.svg";